<template>
  <el-popover placement="bottom-start" width="200" trigger="click">
    <div class="table-column-set--btn">
        <el-button type="text" @click="handleReset">{{$t("text.reset")}}</el-button>
    </div>
    <el-tree
      ref="tree"
      :data="localColumns"
      node-key="prop"
      @node-drop="handleDragEnd"
      :default-checked-keys="selectedColumns.map((v) => v.prop)" 
     
      show-checkbox
      draggable
      :allow-drop="allowDrop"
      @check="handleCheckChange"
    >
    </el-tree>

    <i slot="reference" class="el-icon-setting"></i>
  </el-popover>
</template>

<script>

export default {
  name: "TableColumnSetting",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      defaultColumns: [...this.columns],
      localColumns: [...this.columns],
      selectedColumns: [...this.columns],
      refreshTree:true
    };
  },
  methods: {
    handleDragEnd(draggingNode, dropNode, dropType, ev) {
      this.selectedColumns = this.$refs.tree.getCheckedNodes();
      this.$nextTick(() => {
        this.$refs.tree.setChecked(
          draggingNode.data.prop,
          draggingNode.checked
        );
        this.selectedColumns = this.$refs.tree.getCheckedNodes();
      });
    },
    handleCheckChange(_, data) {
      this.selectedColumns = data.checkedNodes;
    },
    allowDrop(draggingNode, dropNode, type) {
      return type !== "inner";
    },
    handleReset() {
      this.selectedColumns = []
      this.$nextTick(() => {
        this.localColumns = [...this.defaultColumns];
        this.selectedColumns = [...this.defaultColumns];
      });
    }
  },
  watch: {
    selectedColumns(newValue) {
      this.$emit("change", newValue);
    },
  },


  mounted() {
    this.defaultColumns.forEach((item, index) => {
      if (item.fixed) {
        this.$refs.tree.$el.children[index].style.display = "none";
      }
    });
  },
};
</script>

<style scoped lang="scss">
.el-icon-setting {
  cursor: pointer;
  font-size: 20px;
  &:hover {
    color: var(--color-primary);
  }
}
.el-tree {
  max-height: 400px;
  overflow: auto;
  ::v-deep .el-tree-node__content {
    display: flex;
    &::before {
      content: "";
      display: inline-block;
      cursor: grab;
      width: 10px;
      height: 20px;
      background-size: 100% auto !important;
      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACWSURBVHgBbZDREcIgEEQX0oAlUIIlpBQ7sgRLsISU4PivLlRgGtCTUy/ckOwMA+zdwZsFqkju4VTvu7pGPccbeRCEy4N5ai3hXL1Ja3EAslrylquVXyJF98E/iU7mxf991WCeMdAzkFkZaAxfCTD3054hbTAkzzCvEX6eMTzvLKc2XY7qaVgLQ4CkNiyWbLL/xj4Li/8D0OVYob4k8u8AAAAASUVORK5CYII=)
        no-repeat;
    }
  }
}
.table-column-set--btn {
    display: flex;
    justify-content: flex-end;
}
</style>
